<template>
  <div class="page">
    <div class="container">
      <div class="title">用户信息</div>
      <List class="info" border>
        <ListItem>
          <div class="ivu-list-item-meta">
            <div class="ivu-list-item-meta-avatar">
              <span class="ivu-avatar ivu-avatar-circle ivu-avatar-image ivu-avatar-default">
                <img :src="avatarUrl" />
              </span>
            </div>
            <div class="ivu-list-item-meta-content">
              <div class="ivu-list-item-meta-title">姓名：{{userInfo.name?userInfo.name:'-'}}</div>
              <div
                class="ivu-list-item-meta-title"
              >{{userInfo.identityType?userInfo.identityType:'身份类型'}}：{{userInfo.identityNumber?userInfo.identityNumber:'-'}}</div>
              <div class="ivu-list-item-meta-title">报考车型：{{userInfo.license?userInfo.license:'-'}}</div>
              <div
                class="ivu-list-item-meta-title"
              >累计训练时长：{{userInfo.train_time?Math.ceil(userInfo.train_time/1000/60):'-'}}分钟</div>
            </div>
          </div>
        </ListItem>
      </List>
      <Table :columns="columns" :data="list" border disabled-hover :loading="loading"></Table>
      <Button class="go-total" type="primary" @click="onTotal">查看训练总览</Button>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "TodaySummary",
  data() {
    return {
      loading: false,
      columns: [
        {
          title: `今日训练详情(${moment().format("YYYY-MM-DD")})`,
          align: "left",
          children: [
            {
              title: `训练时长：0分钟`,
              align: "left",
              children: [
                {
                  title: "项目名称",
                  key: "course",
                  minWidth: 60,
                  align: "center"
                },
                {
                  title: "训练次数",
                  key: "train_times",
                  minWidth: 45,
                  align: "center"
                },
                {
                  title: "0扣分完成次数",
                  key: "perfect_count",
                  minWidth: 45,
                  align: "center"
                },
                {
                  title: "出错次数",
                  minWidth: 45,
                  align: "center",
                  render: (h, params) => {
                    let course_name = params.row.course;
                    let error_count = 0;
                    let error_map = params.row.error_map;
                    for (let key in error_map) {
                      error_count += error_map[key];
                    }
                    return h(
                      "div",
                      {
                        style: {
                          color: "#0000ff",
                          textDecoration: "underline"
                        },
                        on: {
                          click: () => {
                            this.onDetail({ error_map, course_name });
                          }
                        }
                      },
                      error_count
                    );
                  }
                }
              ]
            }
          ]
        }
      ],
      list: [],
      userInfo: {},
      avatarUrl: ""
    };
  },
  created() {
    this.avatarUrl = this.$route.query.avatarUrl;
    let kangdaId = this.$route.query.id;
    if (!Number.isFinite(parseInt(kangdaId))) return;
    this.loading = true;
    this.$post("/serviceapi/fetchKangdaSummary", { kangdaId }, data => {
      this.updateView(data);
    });
  },
  methods: {
    updateView(data) {
      this.userInfo = data.userInfo;

      let summary = data.summary;
      if (!summary) {
        this.loading = false;
        return;
      }

      let columns = this.columns;
      let header1 = columns[0];
      header1.title = `今日训练详情(${summary.date})`;
      let header2 = header1.children[0];
      header2.title = `训练时长：${Math.ceil(summary.time / 1000 / 60)}分钟`;
      this.columns = columns;

      let details = summary.details;
      let listObj = this.integrate(details);
      let list = this.transformList(listObj);
      this.list = list;

      this.loading = false;
    },
    integrate(details) {
      let listObj = {};
      for (let i in details) {
        let item = details[i];
        let title = item.course;
        if (item.course === "防御性课程及应急处置") {
          title = item.part;
        }
        if (!listObj[title]) {
          listObj[title] = {};
          listObj[title].perfect = [];
          listObj[title].train_times = 0;
          listObj[title].error_map = {};
        }
        listObj[title].perfect.push(item.perfect || 0);
        listObj[title].train_times += item.train_times;
        for (let key in item.error_map) {
          let value = item.error_map[key];
          if (!listObj[title].error_map[key]) {
            listObj[title].error_map[key] = 0;
          }
          listObj[title].error_map[key] += value;
        }
      }
      return listObj;
    },
    transformList(listObj) {
      let list = [];
      for (let key in listObj) {
        let value = listObj[key];
        let obj = {};
        obj.course = key;
        obj.train_times = value.train_times;
        obj.perfect_count = 0;
        for (let i in value.perfect) {
          obj.perfect_count += value.perfect[i];
        }
        obj.error_map = value.error_map;
        list.push(obj);
      }
      return list;
    },
    onDetail(data) {
      this.$router.push({ name: "ErrorDetail", params: { data: data } });
    },
    onTotal() {
      this.$router.push({
        name: "TotalSummary",
        params: { data: this.userInfo.user }
      });
    }
  }
};
</script>

<style scoped>
.page {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  background-color: #eff3f6;
  overflow: scroll;
}
.container {
  width: 95%;
  font-size: 26px;
  display: flex;
  flex-flow: column nowrap;
  margin: 30px auto;
}
.title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-top: 1px solid #dcdee2;
  border-left: 1px solid #dcdee2;
  border-right: 1px solid #dcdee2;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  font-weight: 500;
  padding: 18px 12px;
  color: #515a6e;
  font-size: 20px;
  font-weight: bold;
  line-height: 22px;
  background-color: white;
}
.info {
  margin-bottom: 20px;
}
.go-total {
  width: 80%;
  margin: 15px auto;
}
>>> .ivu-list-item-meta-content {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
}
>>> .ivu-avatar {
  width: 100px;
  height: 100px;
  border-radius: unset;
}
>>> .ivu-list-item-meta-avatar {
  margin-top: 16px;
}
>>> .ivu-list-item {
  padding: 12px;
  background-color: white;
}
>>> .ivu-list-bordered {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
>>> .ivu-table th {
  background-color: #ffffff;
}
>>> .ivu-btn-primary {
  background-color: #6aa7e9;
  border-color: #6aa7e9;
}
</style>


// WEBPACK FOOTER //
// src/components/TodaySummary.vue